/**
 * Dozwolony zakres roczników dla dat, które trafiają do Symfonii FK.
 *
 * DLACZEGO TO ISTNIEJE (regresja z 8–9.09.2026, kosztowała pół dnia diagnozy):
 * silnik Symfonii przepisuje daty do starego obiektu COM, którego zakres dat zaczyna
 * się pod koniec XIX wieku. Data z rocznikiem poza tym zakresem wywala ich usługę
 * wyjątkiem `System.OverflowException: Niedozwolona data OleAut` → HTTP 500 z gołym
 * `{"Message":"An error has occurred."}` i PUSTĄ listą uwag, czyli bez ani jednej
 * wskazówki, które pole zawiniło. Realny przypadek: literówka w polu „Okres" wiersza
 * rejestru VAT — rok `0006` zamiast `2026`.
 *
 * Nasza dotychczasowa walidacja dat tego NIE łapała: sprawdzała, czy data istnieje
 * w kalendarzu (`0006-09-07` istnieje), ale nie czy jest sensowna. Stąd ta bramka —
 * literówka ma być odrzucona u nas, z czytelnym komunikatem, a nie zdiagnozowana
 * z dziennika cudzego serwera.
 *
 * Górna granica jest po tej samej stronie zdrowego rozsądku: rok 9999 przechodzi
 * kalendarz, a w ewidencji podatkowej nie znaczy nic dobrego.
 */

export const FK_MIN_DATE_YEAR = 1900;
export const FK_MAX_DATE_YEAR = 2100;

/**
 * `true`, gdy rocznik daty ISO (`YYYY-MM-DD`) mieści się w zakresie obsługiwanym przez
 * silnik Symfonii. Rocznik czytamy z LITERAŁU, nie przez `new Date()` — parsowanie bez
 * strefy przesuwa datę o offset maszyny i `1900-01-01` wychodzi w Polsce jako rok 1899.
 *
 * Nie waliduje formatu ani istnienia daty w kalendarzu — to robią osobne reguły obok.
 */
export function isFkSafeDateYear(isoDate: string): boolean {
  const year = Number(isoDate.slice(0, 4));
  return Number.isInteger(year) && year >= FK_MIN_DATE_YEAR && year <= FK_MAX_DATE_YEAR;
}
